import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { breadcrumbs } from '~/chords/Breadcrumbs/utils/variants';
import { cn } from '~/chords/lib/cn';
import { useBrand } from '~/modules/branding';

export function BreadcrumbsItem({
  to,
  children,
  ...delegatedProps
}: Omit<Partial<LinkProps>, 'className'>) {
  const brand = useBrand();
  const { item, itemText, itemLink } = breadcrumbs({
    variant: brand.name,
  });

  if (!to) {
    return (
      <span
        {...delegatedProps}
        aria-current="page"
        className={cn(item(), itemText())}
      >
        {children}
      </span>
    );
  }

  return (
    <Link {...delegatedProps} to={to} className={cn(item(), itemLink())}>
      {children}
    </Link>
  );
}

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
